import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.keepalived = bracketIndenting({
	line: "#",
})
